import { Component, ViewEncapsulation, ElementRef, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NavService, Menu } from '../../service/nav.service';
import { k } from 'src/environments/properties';
import { AuthService } from 'src/app/core/services/AuthService';
import { BrandingService } from 'src/app/core/services/branding.service';
import { InstitutionSettings } from 'src/app/core/services/institution-settings.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent {

  public menuItems: Menu[];
  public url: any;
  public fileurl: any;
  public user_name: any
  settings: InstitutionSettings | null = null;

  userToken: any;
  nombreRol: string;
  logoUrl: string | null = null;


  constructor(
    private router: Router,
    public navServices: NavService,
    private elementRef: ElementRef,
    public auth: AuthService,
    public brandingService: BrandingService,
    private authService: AuthService,     
  ) {
    this.navServices.items.subscribe(menuItems => {
      this.menuItems = menuItems
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          menuItems.filter(items => {
            if (items.path === event.url)
              this.setNavActive(items)
            if (!items.children) return false
            items.children.filter(subItems => {
              if (subItems.path === event.url)
                this.setNavActive(subItems)
              if (!subItems.children) return false
              subItems.children.filter(subSubItems => {
                if (subSubItems.path === event.url)
                  this.setNavActive(subSubItems)
              })
            })
          })
        }
      })
    })
  }

  async ngOnInit() {
    this.logoUrl =
      this.brandingService.getLogoUrl() ||
      'assets/images/dashboard/logo-oscuro.png';
    this.user_name = localStorage.getItem(k.user_name);

    this.brandingService.settings$.subscribe(s => {
      this.settings = s;
    });

    this.userToken = localStorage.getItem(k.token);

    if (this.userToken) {
      const dataUser = await this.authService.dataUser(this.userToken);
      const exists = dataUser?.roles.some(r => r.nombre === 'ADMINISTRADOR');

      if (exists) {
        this.nombreRol = 'ADMINISTRADOR';
      } else {
        this.nombreRol = 'FIRMANTE';
      }
    }
  }

  canShow(menu: Menu): boolean {
    if (!menu.roles || menu.roles.length === 0) return true; // si no define roles, se muestra
    
    return this.auth.hasAnyRole(menu.roles); // usa los roles que vienen desde el JWT
  }

  filteredChildren(parent: Menu): Menu[] {
    return (parent.children || []).filter(item => this.canShow(item));
  }
  

  // Active Nave state
  setNavActive(item) {
    this.menuItems.filter(menuItem => {
      if (menuItem != item)
        menuItem.active = false
      if (menuItem.children && menuItem.children.includes(item))
        menuItem.active = true
      if (menuItem.children) {
        menuItem.children.filter(submenuItems => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true
            submenuItems.active = true
          }
        })
      }
    })
  }

  // Click Toggle menu
  toggletNavActive(item) {
    if (!item.active) {
      this.menuItems.forEach(a => {
        if (this.menuItems.includes(item))
          a.active = false
        if (!a.children) return false
        a.children.forEach(b => {
          if (a.children.includes(item)) {
            b.active = false
          }
        })
      });
    }
    item.active = !item.active
  }

  //Fileupload
  readUrl(event: any) {
    if (event.target.files.length === 0)
      return;
    //Image upload validation
    const mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    // Image upload
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.url = reader.result;
    }
  }

  onLogoError(event: any) {
    if (!event.target.src.includes('logo-oscuro.png')) {
      event.target.src = 'assets/images/dashboard/logo-oscuro.png';
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {

    // Solo aplica en móvil
    if (window.innerWidth >= 991) {
      return;
    }

    // Si el menú ya está cerrado
    if (this.navServices.collapseSidebar) {
      return;
    }

    const clickedInsideSidebar =
      this.elementRef.nativeElement.contains(event.target);

    const clickedToggle =
      (event.target as HTMLElement).closest('#sidebar-toggle');

    if (!clickedInsideSidebar && !clickedToggle) {
      this.navServices.collapseSidebar = true;
    }
  }

  collapseSidebar() {
    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
    }
  }

}
